import { Component, OnInit } from '@angular/core';
import { BtnTransitionBaseComponent } from '../btn-transition.component';
import { DemandService } from '@app/shared/services/demand/demand.service';
import Toast from '@app/shared/helpers/toast';
import { DemandStateCode } from '@app/shared/models/demand-state';
import { Demand } from '@app/shared/models/demand';
import { AuthenticationService } from '@app/authentication/authentication.service';
import { demandMatchState } from '@app/shared/helpers/demand-helper';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationInputModalComponent } from '@app/components/modals/confirmation-input-modal/confirmation-input-modal.component';
import { userIsExploitant } from '@app/shared/helpers/user-modes-helper';

@Component({
  selector: 'app-btn-reprendre-demand',
  templateUrl: '../btn-transition.component.html',
  styleUrls: ['../btn-transition.component.scss'],
})
export class BtnReprendreDemandComponent extends BtnTransitionBaseComponent implements OnInit {
  constructor(
    private demandService: DemandService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog
  ) {
    super(authenticationService);
    this.buttonText = 'Reprendre';
    this.raisedBtn = true;
  }

  ngOnInit() {}

  ngOnChanges() {
    this.stateCode = {
      [DemandStateCode.SUSPENDUE]: DemandStateCode.EN_COURS,
      [DemandStateCode.EN_ATTENTE_ABANDON]: DemandStateCode.EN_COURS,
      [DemandStateCode.EN_ATTENTE_CLOTURE]: DemandStateCode.EN_COURS,
      [DemandStateCode.REJETEE]: DemandStateCode.EN_COURS,
      [DemandStateCode.A_COMPLETER]: DemandStateCode.AFFECTEE,
    }[this.demand.workflow_current_state.code];
  }

  checkVisibility(): boolean {
    return demandMatchState(this.demand, 
      [DemandStateCode.SUSPENDUE, 
      DemandStateCode.EN_ATTENTE_ABANDON,
      DemandStateCode.EN_ATTENTE_CLOTURE, 
      DemandStateCode.REJETEE, 
      DemandStateCode.A_COMPLETER]) 
      && this.checkVisibilityTypology();
  }

  checkVisibilityTypology() {
    return userIsExploitant();
  }

  onClick() {
    this.loading = true;
    // Message required to resume demand on state...
    if(demandMatchState(this.demand, [DemandStateCode.EN_ATTENTE_ABANDON, DemandStateCode.EN_ATTENTE_CLOTURE])) {
      this.updateWithMessage();
    // Message not required
    } else {
      this.updateWithoutMessage();
    }
  }

  updateWithMessage() {
    const dialogRef = this.dialog.open(ConfirmationInputModalComponent, {
      data: {
        title: 'Reprendre la demande',
        messageMaxLength: 3000,
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        this.demandService.updateTransition(this.demand.id, this.stateCode, result.message).subscribe(
          (response) => this.onSuccess(response), 
          (error) => this.onError(error)
        );
      } else {
        this.loading = false;
      }
    });
  }

  updateWithoutMessage() {
    this.demandService.updateTransition(this.demand.id, this.stateCode).subscribe(
      (response) => this.onSuccess(response),
      (error) => this.onError(error)
    );
  }

  onSuccess(response) {
    const newStatusLabelForToast: string = this.demand.next_states.find((s) => {
      return [
        DemandStateCode.AFFECTEE,
        DemandStateCode.EN_COURS,
      ].map(String).includes(s.code);
    }).label.substring(8);

    Toast.info(`Votre demande n° ${this.demand.id} est de nouveau au statut "${newStatusLabelForToast}".`);
    this.demandService.updateDemand(response.demand);
    this.loading = false;
  }

  onError(error) {
    Toast.error(`Une erreur a eu lieu pendant la modification de votre demande n° ${this.demand.id}.`);
    console.error(error);
    this.loading = false;
  }
}
